const TEAMS_PROTOCOL_PREFIX = 'msteams://';
const TEAMS_CALL_PATH = 'teams.microsoft.com/l/call/0/0?users=';
const TEAMS_CHAT_PATH = 'teams.microsoft.com/l/chat/0/0?users=';

export const createTeamsCallLink = (email: string): string => {
  return `${TEAMS_PROTOCOL_PREFIX}${TEAMS_CALL_PATH}${encodeURIComponent(email)}`;
};

export const createTeamsChatLink = (email: string): string => {
  return `${TEAMS_PROTOCOL_PREFIX}${TEAMS_CHAT_PATH}${encodeURIComponent(email)}`;
};

export const openExternalLink = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
